import { useCallback } from 'react';

import useSecurityStore, { SecurityPayload } from '../Security/stores/useSecurity.store';
import useUserVerificationStatusStore, { UserVerificationStatus } from '../UserVerificationStatus/stores/useUserVerificationStatus.store';

export type RegistrationAndLoginPayload = SecurityPayload & UserVerificationStatus;

export default () => {
  const handleSetSecuritySourceState = useSecurityStore((state) => state.setSourceState);
  const handleSetSecurityState = useSecurityStore((state) => state.setState);
  const handleResetSecurityState = useSecurityStore((state) => state.handleReset);
  const handleSetErrorsSecurityState = useSecurityStore((state) => state.setErrors);

  const handleSetVerificationStatusSourceState = useUserVerificationStatusStore((state) => state.setSourceState);
  const handleSetVerificationStatusState = useUserVerificationStatusStore((state) => state.setState);
  const handleResetVerificationStatusState = useUserVerificationStatusStore((state) => state.handleReset);
  const handleSetErrorsVerificationStatusState = useUserVerificationStatusStore((state) => state.setErrors);

  const handleSetSourceState = useCallback((values: Partial<RegistrationAndLoginPayload>) => {
    handleSetSecuritySourceState(values);
    handleSetSecurityState(values);
    handleSetVerificationStatusSourceState(values);
    handleSetVerificationStatusState(values);
  }, [handleSetSecuritySourceState, handleSetSecurityState, handleSetVerificationStatusSourceState, handleSetVerificationStatusState]);

  const handleReset = useCallback(() => {
    handleResetSecurityState();
    handleResetVerificationStatusState();
  }, [handleResetSecurityState, handleResetVerificationStatusState]);

  const handleSetErrors = useCallback((values: Partial<RegistrationAndLoginPayload>) => {
    handleSetErrorsSecurityState(values);
    handleSetErrorsVerificationStatusState(values);
  }, [handleSetErrorsSecurityState, handleSetErrorsVerificationStatusState]);

  return {
    handleSetSourceState,
    handleReset,
    handleSetErrors,
  };
};
